/**
 * Toast Context Definition
 *
 * Separated from provider for React Fast Refresh compatibility.
 */

import { createContext } from 'react';

export type ToastType = 'success' | 'error' | 'warning' | 'info';

export interface ToastOptions {
  /**
   * A toast with this id replaces the one showing under it, in place, and
   * `dismiss(id)` removes it: one toast can follow a process from "waiting"
   * to its outcome.
   */
  id?: string;
}

export interface ToastContextType {
  addToast: (type: ToastType, message: string, duration?: number, options?: ToastOptions) => void;
  success: (message: string, duration?: number, options?: ToastOptions) => void;
  error: (message: string, duration?: number, options?: ToastOptions) => void;
  warning: (message: string, duration?: number, options?: ToastOptions) => void;
  info: (message: string, duration?: number, options?: ToastOptions) => void;
  /** Remove the toast showing under `id`, if any. */
  dismiss: (id: string) => void;
}

export const ToastContext = createContext<ToastContextType | undefined>(undefined);
